import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function GoogleCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { loginWithGoogleCode } = useAuth();
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) return;
    handledRef.current = true;

    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const error = searchParams.get('error');

    if (error) {
      navigate('/login?error=google_cancelled');
      return;
    }

    const savedState = sessionStorage.getItem('googleOAuthState');
    sessionStorage.removeItem('googleOAuthState');

    if (!code || !state || state !== savedState) {
      navigate('/login?error=google_failed');
      return;
    }

    loginWithGoogleCode(code).then((result) => {
      if (result.success) {
        navigate(result.isNewUser ? '/language-setup' : '/dashboard');
      } else {
        navigate('/login?error=google_failed');
      }
    });
  }, [searchParams, navigate, loginWithGoogleCode]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <p className="text-muted-foreground">Signing you in with Google...</p>
    </div>
  );
}

export default GoogleCallback;
